<template>
  <b-row>
    <b-col>
      <h5
        class="d-flex justify-content-between align-items-center pointer"
        @click="toggle"
        @keydown="toggle"
      >
        <span class="text-primary">
          {{ title }}
        </span>
        <i :class="iconClass" />
      </h5>
      <b-collapse v-model="show" class="mt-2">
        <b-form-group>
          <b-alert v-if="state.error" variant="warning" show>
            {{ state.error }}
          </b-alert>
          <slot v-else-if="state.data" :data="state.data" />
        </b-form-group>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'BaseFilter',
  props: {
    title: {
      type: String,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      show: true
    }
  },
  computed: {
    iconClass() {
      return this.show ? 'fas fa-minus' : 'fas fa-plus'
    }
  },
  methods: {
    toggle() {
      this.show = !this.show
    }
  }
}
</script>
